import { useGoogleAnalytics } from "client/hooks/utils/useGoogleAnalytics";
import { useToggle } from "client/hooks/utils/useToggle";
import { getRandomId } from "client/utils/getRandomId";
import { selectText } from "client/utils/selectText";
import { addTextBox, deletePadding, setPadding } from "store/features/memeGenerator/actions";
import { PaddingType } from "store/features/memeGenerator/types/padding";
import { useAppDispatch, useAppSelector } from "store/store";
import { useMemeDeviceUpload } from "./useMemeDeviceUpload";

const DEFAULT_TYPE = PaddingType.TOP;

export const useButtons = () => {
    const dispatch = useAppDispatch();
    const isPaddingApplied = !!useAppSelector((state) => state.memeGenerator.meme?.padding.isApplied);
    const { isOpen: isIconsModalOpen, onClose: closeIconsModal, open: openIconsModal } = useToggle();

    function handleAddTextIconClick() {
        const id = getRandomId();
        dispatch(addTextBox({ id }));
        setTimeout(() => {
            const textBox = document.getElementById(`textBox-${id}`);
            textBox && selectText(textBox);
        }, 50);
    }

    const { gtag: onAddPaddingGtag } = useGoogleAnalytics();

    function handlePaddingClick() {
        if (isPaddingApplied) {
            dispatch(deletePadding());
        } else {
            onAddPaddingGtag("event", "meme_add_padding", {
                page: "meme generator",
            });
            dispatch(
                setPadding({
                    isApplied: true,
                    type: DEFAULT_TYPE,
                }),
            );
        }
    }

    const { handleMemeDeviceUpload } = useMemeDeviceUpload();

    function handleUploadClick() {
        handleMemeDeviceUpload();
    }

    const { gtag: openIconsModalGtag } = useGoogleAnalytics();

    async function handleAddIconClick() {
        openIconsModal();
        openIconsModalGtag("event", "icon_modal_opened", {
            page: "meme generator",
        });
    }

    return {
        isPaddingApplied,
        handleAddTextIconClick,
        handlePaddingClick,
        handleUploadClick,
        handleAddIconClick,
        isIconsModalOpen,
        closeIconsModal,
    };
};
